/**
 * This function is used to map the field name from snake_case to camelCase
 * */
export const snake2Camel = (snakeCase) => {
	return snakeCase.replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''))
}

/**
 * The function is used to map the field name from camelCase to snake_case
 * @return Array of the object with the field name in camelCase
 * */
export const transformKeys = (obj) => {
	if (!obj) return obj
	const newObj = {}
	for (const key in obj) {
		if (obj.hasOwnProperty(key)) {
			const camelKey = snake2Camel(key)
			newObj[camelKey] = obj[key]
		}
	}

	return newObj
}
